// src/assets/js/pages/info/main.js

import { initHeaderActiveNav, initHeaderCTA } from '../common/header.js';

document.addEventListener('DOMContentLoaded', async () => {
	initHeaderActiveNav();
	initHeaderCTA();

	// Hydrate About (version / release notes / license)
	await hydrateAbout(document);

	// Deep-link inicial
	if (location.hash) {
		highlightSectionFromHash(location.hash);
	}

	// Cambios de hash sin recargar (footer / navegación interna)
	window.addEventListener('hashchange', () => {
		highlightSectionFromHash(location.hash);
	});
});

function highlightSectionFromHash(hash) {
	const id = String(hash || '')
		.replace('#', '')
		.trim();
	if (!id) return;

	const el = document.getElementById(id);
	if (!el) return;

	// scroll suave hacia la sección
	el.scrollIntoView({ behavior: 'smooth', block: 'start' });

	// resaltar la card contenedora
	const card = el.closest('.panel-card') || el.closest('.plan-card') || el;

	// limpiar anteriores
	document.querySelectorAll('.is-highlighted').forEach((n) => n.classList.remove('is-highlighted'));

	// aplicar
	card.classList.add('is-highlighted');

	// quitar tras unos segundos
	window.clearTimeout(card.__highlightTimeoutId);
	card.__highlightTimeoutId = window.setTimeout(() => {
		card.classList.remove('is-highlighted');
	}, 4200);
}

async function hydrateAbout(bodyEl) {
	const root = bodyEl.querySelector('[data-page="legal-about"]');
	if (!root) return;

	const set = (key, value) => {
		const el = root.querySelector(`[data-about="${key}"]`);
		if (el) el.textContent = value ?? '—';
	};

	// helpers para cargar textos (release notes / license)
	const setPre = (key, text, { emptyFallback = 'No disponible' } = {}) => {
		const el = root.querySelector(`[data-about="${key}"]`);
		if (!el) return;

		const t = (text ?? '').trim();
		el.textContent = t || emptyFallback;
	};

	let v = null;
	let s = {};

	// 1) version.json (puede no existir en dev)
	const versionDetailsEl = root.querySelector('[data-about="versionDetails"]');

	try {
		const res = await fetch('/version.json', { cache: 'no-store' });
		if (res.ok) {
			v = await res.json();
			set('name', v.name || 'SelectivIA');
			set('version', v.version || '—');

			s = v.selectivia || {};
			set('tag', s.tag || '—');
			set('channel', s.channel || '—');
			set('codename', s.codename || '—');
			set('buildTimestamp', s.buildTimestamp || '—');

			const commit = s.gitCommit ? String(s.gitCommit).slice(0, 12) : '—';
			set('gitCommit', commit);

			// ✅ Importante: este <pre> SOLO muestra estado / mensaje.
			// Si todo va bien, lo ocultamos.
			if (versionDetailsEl) {
				versionDetailsEl.style.display = 'none';
				versionDetailsEl.textContent = '';
			}
		} else {
			console.warn('[about] version.json not found (dev mode?)');
			if (versionDetailsEl) {
				versionDetailsEl.style.display = 'inline-flex';
				versionDetailsEl.textContent = 'Información de versión no disponible';
			}
		}
	} catch (err) {
		console.warn('[about] version.json not available:', err);
		if (versionDetailsEl) {
			versionDetailsEl.style.display = 'inline-flex';
			versionDetailsEl.textContent = 'Información de versión no disponible';
		}
	}

	// 2) Resto de campos (siempre visibles, pero si no existen en HTML no pasa nada)
	set('project', s.project || v?.project || '—');
	set('environment', s.environment || v?.environment || '—');

	// 3) Release notes y licencia (los copias a prod con copy:prod)
	//    - RELEASE_NOTES.md -> /RELEASE_NOTES.md
	//    - LICENSE.md -> /LICENSE.md
	try {
		const [notesRes, licenseRes] = await Promise.all([
			fetch('/RELEASE_NOTES.md', { cache: 'no-store' }),
			fetch('/LICENSE.md', { cache: 'no-store' }),
		]);

		if (notesRes.ok) {
			const notes = await notesRes.text();
			setPre('releaseNotesContent', notes, { emptyFallback: 'Release notes no disponibles' });
		} else {
			setPre('releaseNotesContent', '', { emptyFallback: 'Release notes no disponibles' });
		}

		if (licenseRes.ok) {
			const license = await licenseRes.text();
			setPre('licenseContent', license, { emptyFallback: 'Licencia no disponible' });
		} else {
			setPre('licenseContent', '', { emptyFallback: 'Licencia no disponible' });
		}
	} catch (err) {
		console.warn('[about] RELEASE_NOTES / LICENSE not available:', err);
		setPre('releaseNotesContent', '', { emptyFallback: 'Release notes no disponibles' });
		setPre('licenseContent', '', { emptyFallback: 'Licencia no disponible' });
	}
}
